<template>
  <section id="estatisticas" class="section-shaped m-0 bg-default pb-5 pt-0">
    <div class="row row-grid justify-content-center py-5">
      <h1 class="text-white">Estatísticas</h1>
    </div>
    <div v-if="show" class="container-fluid px-5">
      <div class="row">
        <div
          v-for="(counter, index) in counters"
          :key="index"
          class="col-sm-6 px-1 mx-0 mb-2 col-lg-4 col-md-12">
          <counter
          decimal-separator=","
          style="min-height: 170px"
            :icon="counter.icon"
            :title="counter.title"
            :format="counter.format"
            :to-fixe="counter.toFixe"
            :variant="counter.variant"
            :description="counter.description"
            :value="parseFloat(counter.value)"
          >
          </counter>
        </div>
      </div>
    </div>
    <b-container v-else>
      <b-row style="height: 50px" class="mb-5" align-v="center">
        <b-col class="text-center">
          <spinner type="grow" variant="white" v-if="error !== true"></spinner>
          <div v-else>
            <h5 class="text-muted">Não foi possível carregar as estatísticas</h5>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
  import Counter from '../../components/Counter';
  import Spinner from '../../components/Spinner';

  export default {
    name: 'SectionContadores',
    components: {
      Spinner,
      Counter
    },
    data() {
      return {
        counters: [],
        error: false,
        show: false
      }
    },
    methods: {
      loadCounters(){
        this.$http.get('https://conecta.janelaunica.com.br/api/estatisticas')
          .then(response => {
            this.counters = response.data
            this.show = true
          })
          .catch(() => {
            this.error = true
          })
      }
    },
    mounted() {
      this.loadCounters()
    }
  }
</script>
